import React from 'react';

const ImageModal = ({ show, imageSrc, onClose }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="img-modal-overlay" onClick={onClose}>
            <div className="img-modal-content" onClick={e => e.stopPropagation()}>
                <span className="img-close-btn" onClick={onClose}>&times;</span>
                <img src={imageSrc} alt="Large view" className="img-modal-image" />
            </div>
        </div>
    );
}

export default ImageModal;